// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__tPQdX","modalBody":"addForm_modalBody__ZwrRF","formControl":"addForm_formControl__fkxD6","add":"addForm_add__r40Gp"};